import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { applyConsent, CONSENT_EVENT, getConsent, publicAnalyticsPath, trackPageView } from '../lib/analytics';

export default function useGoogleAnalytics() {
  const { pathname } = useLocation();
  const [consent, setConsent] = useState(getConsent);
  const lastPath = useRef(null);

  useEffect(() => {
    const changed = (event) => setConsent(event.detail);
    const storage = () => setConsent(getConsent());
    window.addEventListener(CONSENT_EVENT, changed);
    window.addEventListener('storage', storage);
    return () => {
      window.removeEventListener(CONSENT_EVENT, changed);
      window.removeEventListener('storage', storage);
    };
  }, []);

  useEffect(() => {
    applyConsent(consent);
    // Do not send private dashboards, token callbacks or intermediate redirects.
    if (!publicAnalyticsPath(pathname)) return;
    if (lastPath.current === pathname) return;
    // Allow the route's SEO title to update; cancelled effects cannot double-count.
    const timer = window.setTimeout(() => {
      trackPageView(pathname, lastPath.current);
      lastPath.current = pathname;
    }, 100);
    return () => window.clearTimeout(timer);
  }, [pathname, consent]);
}